var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tree"},[_c('ul',_vm._l((_vm.list),function(item){return _c('li',{on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.goRouter(item)}}},[_vm._v(_vm._s(item.title))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }